import { useEffect, useState } from "react";
import { Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import ImpactReportContent from "@/components/report/ImpactReportContent";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export default function PublicReportPage() {
  const { t } = useLang();
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/impact-stats").then((r) => setStats(r.data)).catch(() => {}); }, []);
  if (!stats) return <div className="py-32 text-center text-slate-400 font-semibold">Memuat laporan publik...</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10" data-testid="public-report-page">
      <div className="flex items-center justify-between mb-5 print:hidden">
        <div>
          <h1 className="font-heading font-black text-2xl text-slate-900">{t("rp_public_title")}</h1>
          <p className="text-sm text-slate-500">{t("rp_public_sub")}</p>
        </div>
        <Button data-testid="public-report-print-btn" onClick={() => window.print()} className="rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold">
          <Printer className="w-4 h-4 mr-2" /> {t("rp_public_print")}
        </Button>
      </div>
      <div className="rounded-2xl border border-slate-200 overflow-hidden shadow-[0_8px_32px_rgba(0,0,0,0.06)]">
        <ImpactReportContent stats={stats} />
      </div>
    </div>
  );
}
